/* Server-rendered shopping stays usable without JavaScript. */
if (!customElements.get('ziwi-bundle-shop')) {
  customElements.define('ziwi-bundle-shop', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.classList.add('is-enhanced');
      this.tabs = [...this.querySelectorAll('[data-pet-tab]')];
      this.groups = [...this.querySelectorAll('[data-pet-group]')];
      this.addEventListener('click', event => {
        const tab = event.target.closest('[data-pet-tab]');
        if (tab) this.selectPet(tab.dataset.petTab);
        const recipe = event.target.closest('[data-recipe]');
        if (recipe) this.selectRecipe(recipe.closest('[data-pet-group]'), recipe.dataset.recipe);
      });
      this.addEventListener('keydown', event => {
        const tab = event.target.closest('[data-pet-tab]');
        if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const index = this.tabs.indexOf(tab);
        let next = event.key === 'ArrowRight' ? (index + 1) % this.tabs.length : (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        this.selectPet(this.tabs[next].dataset.petTab);
        this.tabs[next].focus();
      });
      this.addEventListener('change', event => {
        if (event.target.matches('[data-bundle-variant]')) this.updateVariant(event.target);
      });
      this.groups.forEach(group => this.selectRecipe(group, group.querySelector('[data-recipe]')?.dataset.recipe));
      this.querySelectorAll('[data-bundle-variant]:checked').forEach(input => this.updateVariant(input));
      /* Honour the tab the template marked selected, rather than always taking the first.
         The buttons are ordered dog-then-cat for brand reasons (the icons face outward that
         way), which is independent of which pet's bundles should show on load. */
      const preselected = this.tabs.find(tab => tab.getAttribute('aria-selected') === 'true');
      this.selectPet((preselected || this.tabs[0])?.dataset.petTab);
    }
    selectPet(pet) {
      this.tabs.forEach(tab => {
        const selected = tab.dataset.petTab === pet;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      this.groups.forEach(group => { group.hidden = group.dataset.petGroup !== pet; });
    }
    selectRecipe(group, id) {
      if (!group || !id) return;
      group.querySelectorAll('[data-recipe-panel]').forEach(panel => { panel.hidden = panel.dataset.recipePanel !== id; });
      group.querySelectorAll('[data-recipe]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.recipe === id)));
    }
    updateVariant(input) {
      const panel = input.closest('[data-recipe-panel]');
      const data = input.dataset;
      panel.querySelector('[data-price]').textContent = data.price;
      panel.querySelector('[data-unit]').textContent = data.unit;
      [['[data-compare]', data.compare], ['[data-save]', data.save]].forEach(([selector, value]) => {
        const element = panel.querySelector(selector);
        if (!element) return;
        element.textContent = value || '';
        element.hidden = !value;
      });
      panel.querySelector('[data-pack]').textContent = data.pack;
      const image = panel.querySelector('[data-bundle-image]');
      if (data.image) {
        image.src = data.image;
        image.srcset = data.srcset;
        image.alt = data.alt;
      }
      panel.querySelector('[name="id"]').value = input.value;
      const available = data.available === 'true';
      const button = panel.querySelector('[data-add]');
      button.disabled = !available;
      button.textContent = available ? data.addLabel : this.dataset.unavailableLabel;
      panel.querySelector('[data-stock]').textContent = available ? this.dataset.availableText : this.dataset.unavailableText;
      panel.querySelector('[data-updates]').hidden = available;
      const link = panel.querySelector('[data-product-link]');
      const url = new URL(link.href);
      url.searchParams.set('variant', input.value);
      link.href = url.toString();
    }
  });
}
